import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { uiFilterTeams, uiTeamsRelationship } from '../actions/ui'
import { fetchTeamsAction, fetchProfileTeamsAction } from '../actions/teamDbActions'
import { Section, TeamList, InlineSearchBox } from '../components'
import { Navbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'

class TeamsView extends Component {
  static propTypes = {
    title: PropTypes.string,
    validRelationships: PropTypes.arrayOf(PropTypes.string),
    userHandle: PropTypes.string,
    filter: PropTypes.string,
    publicOnly: PropTypes.bool
  }

  static defaultProps = {
    validRelationships: null,
    publicOnly: false
  }

  constructor (props) {
    super(props)
    this.loadFilteredTeams = this.loadFilteredTeams.bind(this)
  }

  componentWillMount () {
    const { dispatch, validRelationships } = this.props
    if (validRelationships && validRelationships.length > 0) { dispatch(uiTeamsRelationship(validRelationships[0])) }
  }

  componentDidMount () {
    const { userSession, filter, relationships } = this.props
    if (relationships) { this.getTeamsFetcher(userSession.token, relationships, filter)() }
  }

  componentWillReceiveProps (newProps) {
    const { relationships, userSession, filter } = this.props
    if (relationships !== newProps.relationships || filter !== newProps.filter) {
      this.getTeamsFetcher(userSession.token, newProps.relationships, newProps.filter)()
    }
  }

  isRelationshipAllowed (type) {
    const { validRelationships } = this.props
    return validRelationships ? validRelationships.includes(type) : true
  }

  getTeamsLoader (list, fetcher) {
    return ({ startIndex = 0, stopIndex } = {}) => {
      const total = list.headers ? list.headers.pagination.totalCount : -1
      if ((total < 0 || startIndex < total) && !list.isFetching) { return fetcher(startIndex) }
    }
  }

  getTeamsFetcher (token, relationships, filter) {
    return (start = 0) => {
      const { dispatch, userHandle, publicOnly } = this.props
      if (publicOnly || (relationships && relationships === 'public')) {
        const relationshipFilter = (!relationships || (relationships === 'shared' || relationships === 'public')) ? 'all' : relationships
        dispatch(fetchTeamsAction(token, relationshipFilter, userHandle, start, { filter }))
      } else {
        const relationshipFilter = (!relationships || (relationships === 'shared')) ? 'all' : relationships
        dispatch(fetchProfileTeamsAction(token, relationshipFilter, start, { filter }))
      }
    }
  }

  loadFilteredTeams (filter) {
    this.props.dispatch(uiFilterTeams(filter))
  }

  renderFilterBar () {
    const { dispatch, relationships, validRelationships } = this.props
    const onChange = value => {
      dispatch(uiTeamsRelationship(value))
    }
    const showButtons = relationships && validRelationships && validRelationships.length > 1
    return (
      <Navbar className='search-bar' fluid>
        <Navbar.Form>
          {showButtons && <ToggleButtonGroup
            name='teamRelationship'
            type='radio'
            value={relationships}
            onChange={onChange}
            bsSize='small'
          >
            {this.isRelationshipAllowed('mine') && <ToggleButton value={'mine'}>Yours</ToggleButton>}
            {this.isRelationshipAllowed('shared') && <ToggleButton value={'shared'}>Yours+Member</ToggleButton>}
            {this.isRelationshipAllowed('public') && <ToggleButton value={'public'}>All</ToggleButton>}
          </ToggleButtonGroup>}
          <InlineSearchBox filter={this.props.filter} searchFunction={this.loadFilteredTeams} />
        </Navbar.Form>
      </Navbar>)
  }

  render () {
    const { teams, userSession, relationships, title, publicOnly, userHandle } = this.props
    if (!relationships) { return null }

    const { profileTeams, allTeams } = teams
    const token = userSession.token

    const enableAdd = (relationships === 'mine' || relationships === 'shared') && !userSession.isAnonymous && (!userHandle || userHandle === userSession.profile.handle)

    const list = publicOnly || relationships === 'public' ? allTeams : profileTeams
    const loader = this.getTeamsFetcher(token, relationships)
    return (
      <Section title={title}>
        {this.renderFilterBar()}
        <TeamList enableAdd={enableAdd} list={list} loadMoreRows={this.getTeamsLoader(list, loader)} renderButtons />
      </Section>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return { teams: state.teams, userSession: state.session, relationships: state.ui.teams.relationships, filter: state.ui.teams.filter }
}

export default withRouter(connect(mapStateToProps)(TeamsView))
